import {
  initialState,
  Actions,
  State,
  GET_ONE_COURSE,
  GET_ONE_COURSE_SUCCESS,
  GET_ONE_COURSE_ERROR,
  RESET_GET_ONE_COURSE,
} from "../../types/course/get-one.dto";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case GET_ONE_COURSE:
      console.log('GET_ONE_COURSE')
      return {
        ...state,
        states: {
          loading: true,
          success: false,
          error: false,
        },
      };
    case GET_ONE_COURSE_SUCCESS:
      console.log('GET_ONE_COURSE_SUCCESS')
      return {
        ...state,
        data: JSON.parse(JSON.stringify(action.payload)),
        states: {
          loading: false,
          success: true,
          error: false,
        },
      };
    case GET_ONE_COURSE_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: false,
          success: false,
          error: action.payload,
        },
      };
    case RESET_GET_ONE_COURSE:
      return { ...initialState };
    default:
      return { ...state };
  }
};

export default reducers;
